<template>
	<span v-if="format === 'tag' && story.source && story.source.id !== null" class="source-tag">
		<a @click.prevent="goToSource">{{story.source.name}}</a>
	</span>
	<span
		v-else-if="format === 'text' && story.source && story.source.id !== null"
		class="source-text"
	>
		<a @click.prevent="goToSource">{{story.source.name}}</a>
	</span>
	<span
		v-else-if="format === 'single-story' && story.source && story.source.id !== null"
		class="source-single"
	>
		<a @click.prevent="goToSource">{{story.source.name}}</a>
	</span>
	<span
		v-else-if="format === 'text-only' && story.source && story.source.id !== null"
		class="source-text-only"
	>
		<span>&middot;</span>
		<a @click.prevent="goToSource">{{story.source.name}}</a>
	</span>
</template>

<script>
export default {
	props: {
		story: {
			type: Object
		},
		format: {
			type: String
		}
	},
	methods: {
		goToSource() {
			this.$router.push({
				name: "source",
				params: {
					sourceId: this.story.source && this.story.source.id,
					sourceName: this.story.source && this.story.source.name
				}
			});

			const modalContainer = document.querySelector(".modal-container");
			if (modalContainer !== null) {
				this.closeModal();
			}
		},
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false,
				users: null,
				story: null,
				prevStory: null,
				nextStory: null
			};
			this.$store.commit("updateStoryModal", payload);
		}
	}
};
</script>

<style scoped>
.source-tag {
	color: #b7b7b7;
	position: absolute;
	font-size: 10px;
	font-weight: bold;
	padding: 3px 10px;
	background-color: #000;
	border-radius: 25px;
	left: 10px;
	top: 10px;
	word-wrap: break-word;
}

.source-text {
	color: #b7b7b7 !important;
	font-size: 10px;
	font-weight: bold;
	display: inline-block;
	padding: 3px 10px;
	background-color: #000;
	border-radius: 25px;
}

.source-text-only {
	color: #b7b7b7 !important;
	font-size: 10px;
	font-weight: bold;
	display: inline-block;
}

.source-single {
	color: #b7b7b7 !important;
	font-size: 10px;
	font-weight: bold;
	display: inline-block;
	padding: 3px 10px;
	background-color: #000;
	border-radius: 25px;
	margin: 10px 0 0 15px;
}

.source-text span {
	margin: 0px 2px;
}

a {
	color: #b7b7b7;
	transition: 0.3s all ease;
}

a:hover {
	color: #51c715;
}

@media only screen and (max-width: 940px) {
	.source-single {
		margin-left: 10px;
	}
}

@media only screen and (max-width: 540px) {
	.small-box-container .source-text {
		color: #fff;
		background-color: #171717;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/sources/SourceTag.vue